export default __webpack_public_path__ + "static/media/filters.9dd9a98e.svg";